import { Store } from "shared/src/stores/Store";
import Requests from "shared/src/services/Requests";
import * as _ from "lodash";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import { trackMetroMarketsResult } from "../utils/ZeroSearchResultTrackingUtil";

export type SearchResultItem = {
    id: string;
    name: string;
    image: string;
    bestOffer: {
        price: {
            grossPrice: number;
            netPrice: number;
            currency: string;
        };
    };
};

export type SearchResultState = {
    items: SearchResultItem[];
};

let state: SearchResultState = { items: [] };

class MetroMarketsStore extends Store {
    constructor() {
        super();
    }

    doSearch(query: string) {
        const metroMarketsApiUrl = _.get(CountryUtil.getOptionalConfig(), "metroMarketsApiUrl", null);
        if (metroMarketsApiUrl) {
            const url = metroMarketsApiUrl + "?limit=4&filter[top][phrase]=" + query;
            Requests.get(url, null, { timeout: 3000 }, true).then((result: any) => {
                state = result;
                trackMetroMarketsResult(query, result?.items?.length || 0);
                this.trigger();
            });
        }
    }

    getState(): SearchResultState | undefined | null {
        return state;
    }
}

export default new MetroMarketsStore();
